// src/pages/PrivacyPolicy.tsx
import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="section-padding">
      <div className="container">
        <div className="section-title">
          <h1>Privacy Policy</h1>
          <p>Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

        </div>

        <div className="card" style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                1. Information We Collect
              </h2>
              <p>
                ImanVerse is committed to protecting your privacy. We collect minimal information necessary to provide our services, which may include:
              </p>
              <ul style={{ paddingLeft: '24px', marginTop: '12px' }}>
                <li>Basic usage data and analytics</li>
                <li>Theme preferences stored locally</li>
                <li>Email addresses (only if voluntarily provided for newsletter)</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                2. How We Use Your Information
              </h2>
              <p>
                We use the information we collect to:
              </p>
              <ul style={{ paddingLeft: '24px', marginTop: '12px' }}>
                <li>Improve user experience and platform functionality</li>
                <li>Personalize content and theme preferences</li>
                <li>Send newsletters (only if subscribed)</li>
                <li>Analyze platform usage to enhance our services</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                3. Data Protection
              </h2>
              <p>
                We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                4. Third-Party Services
              </h2>
              <p>
                We may use third-party services such as Google Analytics and payment processors. These services have their own privacy policies governing data use.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                5. Cookies and Local Storage
              </h2>
              <p>
                We use local storage to remember your theme preferences and improve your browsing experience. No personal data is stored without your consent.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                6. Your Rights
              </h2>
              <p>
                You have the right to:
              </p>
              <ul style={{ paddingLeft: '24px', marginTop: '12px' }}>
                <li>Access your personal data</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Opt-out of marketing communications</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                7. Children's Privacy
              </h2>
              <p>
                Our Platform is suitable for users of all ages, but we do not knowingly collect personal information from children under 13 without parental consent.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', color: 'var(--text-primary)' }}>
                8. Contact Us
              </h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at: md.shafee05s@gmail.com
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;